/* ============================================================
   Puddi BYB Builder — section JS
   Ported from puddi_byb_fidelity_v3.html + cart wiring for /cart/add.js
   Reads window.PUDDI_BYB (injected by section liquid) for variant IDs,
   per-cup prices (cents), and thumb URLs.
   ============================================================ */
(function(){
  'use strict';

  // Bail if not on BYB page
  if(!window.PUDDI_BYB) return;
  const CFG = window.PUDDI_BYB;

  // ============ constants ============
  const GRID_COLS = { 6:6, 12:6, 27:9 }; // one row, two rows, three rows
  const SLOT_CLASS = { cr:'f-cr', cn:'f-cn', vr:'f-vr', vn:'f-vn' };
  const ITEM_META = {
    cr:{ name:'Chocolate Dream', nsa:false, thumb:'choco' },
    cn:{ name:'Chocolate Dream', nsa:true,  thumb:'choco' },
    vr:{ name:'Vanilla Bean',    nsa:false, thumb:'van'   },
    vn:{ name:'Vanilla Bean',    nsa:true,  thumb:'van'   }
  };

  // Trust signals — shared 6-item pool. Bar shows 2 shuffled per pageview,
  // sheet check-grid shows all 6 in source order. Kept in sync with cart drawer
  // TRUST until theme-settings port lets both surfaces read from one source.
  const TRUST = [
    "Free shipping in the USA",
    "100% Money-Back Guarantee",
    "Ships in 24 hours",
    "Shelf-stable · no fridge needed",
    "Made in the USA",
    "Order today, spoon tomorrow"
  ];
  const trustItem = t => `<span class="trust-item"><span class="tk">✓</span>${t}</span>`;

  // ============ state ============
  const state = { size:12, counts:{cr:0,cn:0,vr:0,vn:0}, justAdded:null, submitting:false };

  const total = () => state.counts.cr+state.counts.cn+state.counts.vr+state.counts.vn;

  function stateLine(){
    const t = total(), s = state.size;
    if(t===0) return "Your box is looking a little lonely.";
    if(t===s) return "That\u2019s a full box. Nicely done.";
    if(t===s-1) return "One more for the road.";
    if(t>=s/2) return "Halfway there. Keep going.";
    return "Good start. Keep \u2019em coming.";
  }

  function money(cents){ return '$' + (cents/100).toFixed(2); }

  function buildComposition(counts){
    const parts = [];
    for(const k of ['cr','cn','vr','vn']){
      if(counts[k] > 0){
        const m = ITEM_META[k];
        parts.push(`${counts[k]}\u00D7 ${m.name}${m.nsa ? ' No Sugar Added' : ''}`);
      }
    }
    return parts.join(' \u00B7 ');
  }

  // ============ render ============
  function render(){
    const t = total(), s = state.size, full = t===s;
    const priceCents = t * CFG.per_cup_cents[s];

    // Dot grid — desktop right panel
    document.querySelectorAll('[data-zone="slots"]').forEach(grid=>{
      grid.style.gridTemplateColumns = `repeat(${GRID_COLS[s]},13px)`;
      grid.innerHTML = '';
      const fills = [];
      for(const k of ['cr','cn','vr','vn']) for(let i=0;i<state.counts[k];i++) fills.push(k);
      for(let i=0;i<s;i++){
        const d = document.createElement('div');
        d.className = 'slot' + (fills[i] ? ' ' + SLOT_CLASS[fills[i]] : '');
        // pop the last-filled slot of the just-added SKU
        if(state.justAdded && fills[i]===state.justAdded && i === fills.length-1){
          d.classList.add('just-added');
        }
        grid.appendChild(d);
      }
      grid.classList.toggle('full', full);
    });

    // Line items — desktop panel
    document.querySelectorAll('[data-zone="items"]').forEach(zone=>{
      zone.innerHTML = '';
      let any = false;
      for(const k of ['cr','cn','vr','vn']){
        if(state.counts[k] > 0){
          any = true;
          const m = ITEM_META[k];
          const thumbUrl = CFG.thumb_urls[m.thumb] || '';
          const row = document.createElement('div');
          row.className = 'line-item';
          row.innerHTML = `
            <div class="li-thumb ${m.thumb==='van'?'t-van':''}" style="background-image:url('${thumbUrl}')"></div>
            <div class="li-name">
              <b>${m.name}</b>
              ${m.nsa ? '<span class="li-nsa">No Sugar Added</span>' : ''}
            </div>
            <div class="li-step">
              <button class="li-minus" type="button" aria-label="Remove one">\u2212</button>
              <span class="n">${state.counts[k]}</span>
              <button class="li-plus" type="button" aria-label="Add one">+</button>
            </div>`;
          const plus = row.querySelector('.li-plus');
          plus.disabled = full;
          plus.addEventListener('click', ()=>{
            if(total() < state.size){ state.counts[k]++; state.justAdded = k; render(); }
          });
          row.querySelector('.li-minus').addEventListener('click', ()=>{
            if(state.counts[k] > 0){ state.counts[k]--; state.justAdded = null; render(); }
          });
          zone.appendChild(row);
        }
      }
      if(!any) zone.innerHTML = '<div class="li-empty">Pick some cups to get started.</div>';
    });

    // Progress copy (desktop panel + mobile inline line — same data-zone)
    document.querySelectorAll('[data-zone="state"]').forEach(el=>{ el.innerHTML = stateLine(); });

    // Count + price (desktop panel only)
    document.querySelectorAll('[data-zone="count"]').forEach(el=>{ el.textContent = `${t} of ${s} cups`; });
    document.querySelectorAll('[data-zone="price"]').forEach(el=>{ el.textContent = money(priceCents); });

    // Desktop CTA
    document.querySelectorAll('[data-zone="cta"]').forEach(el=>{
      el.disabled = !full || state.submitting;
      el.textContent = state.submitting ? 'Adding\u2026' : (full ? `Add box to cart \u00B7 ${money(priceCents)}` : 'Fill your box first');
    });

    // Mobile sticky bar — mini dots + n/total + state-aware bar CTA
    document.querySelectorAll('[data-zone="dots-mini"]').forEach(zone=>{
      zone.innerHTML = '';
      const fills = [];
      for(const k of ['cr','cn','vr','vn']) for(let i=0;i<state.counts[k];i++) fills.push(k);
      for(let i=0;i<s;i++){
        const d = document.createElement('div');
        d.className = 'dot' + (fills[i] ? ' ' + SLOT_CLASS[fills[i]] : '');
        zone.appendChild(d);
      }
    });
    document.querySelectorAll('[data-zone="m-count"]').forEach(el=>{ el.textContent = `${t}/${s}`; });

    // Bar CTA — state-aware brand-voice copy. Never disabled; behavior depends on state.
    // 0 cups → "Fill your box" (click scrolls to SKU grid)
    // mid-fill → "Peek in your box" (click opens sheet)
    // full → "Full box — take a peek" (click opens sheet)
    document.querySelectorAll('[data-zone="bar-cta"]').forEach(el=>{
      el.textContent = t === 0 ? 'Fill your box' : (full ? 'Full box \u2014 take a peek' : 'Peek in your box');
    });

    // SKU picker cards — sync count badges, has-count state, disable
    document.querySelectorAll('[data-zone="skus"] .sku-card').forEach(card=>{
      const k = card.dataset.sku;
      const n = state.counts[k];
      card.classList.toggle('has-count', n > 0);
      card.querySelectorAll('.n').forEach(el=>{ el.textContent = n; });
      card.querySelectorAll('.badge-n').forEach(el=>{ el.textContent = n; });
      card.querySelectorAll('.plus').forEach(b=>{ b.disabled = full; });
      card.querySelectorAll('.minus').forEach(b=>{ b.disabled = n === 0; });
      card.querySelectorAll('.add-btn').forEach(b=>{ b.disabled = full; });
    });

    // clear justAdded flag after render so pop only fires once
    state.justAdded = null;
  }

  // ============ cart submit ============
  function addBoxToCart(){
    const t = total();
    if(t !== state.size || state.submitting) return;

    const variantId = CFG.variants[state.size];
    if(!variantId){
      console.error('[BYB] Missing variant ID for size', state.size, '\u2014 verify the Build a Box product is created in admin with three variants.');
      alert('Sorry, this box size isn\u2019t available right now. Please try another size.');
      return;
    }

    state.submitting = true;
    render();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            'Composition': buildComposition(state.counts),
            '_composition_data': JSON.stringify(state.counts)
          }
        }]
      })
    })
    .then(response=>{
      if(!response.ok) return response.json().then(err=>{ throw new Error(err.description || 'Add to cart failed'); });
      return response.json();
    })
    .then(()=>{
      state.submitting = false;
      state.counts = {cr:0,cn:0,vr:0,vn:0};
      render();
      window.dispatchEvent(new CustomEvent('cart:updated'));
      closeSheet();
      if(window.PuddiCart) window.PuddiCart.open();
    })
    .catch(err=>{
      console.error('[BYB]', err);
      state.submitting = false;
      render();
      alert('Sorry, something went wrong adding your box. Please try again.');
    });
  }

  // ============ wiring ============
  document.querySelectorAll('[data-zone="skus"] .sku-card').forEach(card=>{
    const k = card.dataset.sku;
    const inc = ()=>{ if(total() < state.size){ state.counts[k]++; state.justAdded = k; render(); } };
    card.querySelectorAll('.plus').forEach(b=>b.addEventListener('click', inc));
    card.querySelectorAll('.add-btn').forEach(b=>b.addEventListener('click', inc));
    card.querySelectorAll('.minus').forEach(b=>b.addEventListener('click', ()=>{
      if(state.counts[k] > 0){ state.counts[k]--; state.justAdded = null; render(); }
    }));
  });

  // Size selector
  document.querySelectorAll('[data-zone="sizes"] .sz').forEach(sz=>{
    sz.addEventListener('click', ()=>{
      state.size = parseInt(sz.dataset.size, 10);
      // trim overflow if downsizing — NSA-first, then vanilla, then chocolate NSA, then chocolate regular
      let t = total();
      const trimOrder = ['vn','vr','cn','cr'];
      while(t > state.size){
        for(const k of trimOrder){
          if(state.counts[k] > 0 && t > state.size){ state.counts[k]--; t--; }
        }
      }
      document.querySelectorAll('[data-zone="sizes"] .sz').forEach(x=>{
        x.classList.toggle('on', parseInt(x.dataset.size, 10) === state.size);
      });
      render();
    });
  });

  // ============ sheet open / close ============
  const stick = document.querySelector('[data-zone="stick"]');

  function openSheet(){
    if(!stick) return;
    stick.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeSheet(){
    if(!stick) return;
    stick.classList.remove('open');
    document.body.style.overflow = '';
  }

  // Scrim tap + Keep adding button → close
  document.querySelectorAll('[data-zone="scrim"], [data-zone="keep"]').forEach(el=>{
    el.addEventListener('click', closeSheet);
  });

  // ESC to close
  document.addEventListener('keydown', e=>{
    if(e.key === 'Escape' && stick && stick.classList.contains('open')) closeSheet();
  });

  // ============ bar CTA — scroll or open sheet ============
  document.querySelectorAll('[data-zone="bar-cta"]').forEach(el=>{
    el.addEventListener('click', ()=>{
      if(total() === 0){
        const grid = document.getElementById('bybSkuGrid');
        if(grid) grid.scrollIntoView({ behavior:'smooth', block:'start' });
      } else {
        openSheet();
      }
    });
  });

  // ============ sheet CTA — add box to cart ============
  document.querySelectorAll('[data-zone="cta"]').forEach(el=>{
    el.addEventListener('click', ()=>{
      if(el.disabled) return;
      addBoxToCart();
    });
  });

  // ============ trust signals — one-time init ============
  // Bar: shuffle and pick 2 per pageview via PuddiShuffle (Working Conventions R6).
  // Sheet check-grid: all 6 in source order.
  if(window.PuddiShuffle){
    const shuffled = window.PuddiShuffle.shuffle(TRUST).slice(0, 2);
    document.querySelectorAll('[data-zone="bar-trust"]').forEach(el=>{
      el.innerHTML = shuffled.map(trustItem).join('');
    });
  }
  document.querySelectorAll('[data-zone="check-grid"]').forEach(el=>{
    el.innerHTML = TRUST.map(trustItem).join('');
  });

  // Initial render
  render();

  // bfcache safety — reset submitting state when the page is restored via back/forward
  window.addEventListener('pageshow', function(){
    if(state.submitting){
      state.submitting = false;
      render();
    }
  });
})();
